module.exports = __webpack_public_path__ + "static/media/embedded2.6b32ca9e.jpg";